import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Mail, MapPin } from "lucide-react";

export default function Contact() {
  const [f, setF] = useState({ name: "", email: "", subject: "", message: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", f);
      toast.success("Message received — asante!");
      setF({ name: "", email: "", subject: "", message: "" });
    } catch { toast.error("Could not send. Please try again."); }
    setBusy(false);
  };

  return (
    <div className="max-w-5xl mx-auto px-5 sm:px-8 py-14 grid md:grid-cols-2 gap-10">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-[#C05A3D] font-semibold">Contact</div>
        <h1 className="font-display text-4xl text-[#1E3A2F] mt-1">Say hello.</h1>
        <p className="text-[#5C5C5C] mt-3">Feedback, partnerships, event tips, or a story we should hear — send it our way.</p>
        <div className="mt-8 space-y-3 text-sm text-[#1A1A1A]">
          <div className="inline-flex items-center gap-2"><Mail className="w-4 h-4 text-[#C05A3D]" /> hello@africanbridgemedia.com</div>
          <div className="flex items-center gap-2"><MapPin className="w-4 h-4 text-[#C05A3D]" /> Washington State, USA</div>
        </div>
      </div>
      <form onSubmit={submit} className="rounded-2xl bg-white border border-[#E2DED0] p-6 space-y-4">
        <div className="grid sm:grid-cols-2 gap-3">
          <div><Label>Name</Label><Input data-testid="contact-name" required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} /></div>
          <div><Label>Email</Label><Input data-testid="contact-email" type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} /></div>
        </div>
        <div><Label>Subject</Label><Input data-testid="contact-subject" required value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} /></div>
        <div><Label>Message</Label><Textarea data-testid="contact-message" required rows={6} value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} /></div>
        <Button data-testid="contact-submit" disabled={busy} className="abm-btn-primary rounded-full">{busy ? "Sending…" : "Send message"}</Button>
      </form>
    </div>
  );
}
